import { BaseModalV2 } from 'components/ui/BaseModal'
import React, { useRef } from 'react'
import { ModalFooter } from 'components/AdminConsole/commonUI/Modal/ModalFooter'
import { ModalHeader } from 'components/AdminConsole/commonUI/Modal/ModalHeader'
import useLocaleText from 'components/useLocaleText'
import { PopFormShell, PopFormShellRef } from '../Form/PopFormShell'
import { RootState } from 'constants/interfaces'
import { useSelector } from 'react-redux'
import { PopFormValues } from '../types'

interface PopModalProps {
  isOpen: boolean
  onClose: () => void
  onRequestClose: () => void
  onCreated?: (data: PopFormValues) => void
  validateOnly?: boolean
  initialPopData?: PopFormValues | null
}

export const PopModal: React.FC<PopModalProps> = ({
  isOpen,
  onClose,
  onRequestClose,
  onCreated,
  validateOnly,
  initialPopData,
}) => {
  const t_create_pop = useLocaleText('create_pop')
  const t_edit_pop = useLocaleText('edit_pop')
  const admin_submit_button = useLocaleText('admin_submit_button')
  const isLoading = useSelector((state: RootState) => state.pops.isLoading)

  const formRef = useRef<PopFormShellRef>(null)

  const handleSubmitClick = () => {
    formRef.current?.submit()
  }

  return (
    <BaseModalV2
      isOpen={isOpen}
      onClose={onClose}
      header={<ModalHeader title={initialPopData ? t_edit_pop : t_create_pop} onClose={onRequestClose} />}
      body={
        <PopFormShell
          ref={formRef}
          onClose={onClose}
          onCreated={onCreated}
          validateOnly={validateOnly}
          initialPopData={initialPopData}
        />
      }
      footer={<ModalFooter isLoading={isLoading} onSubmit={handleSubmitClick} buttonText={admin_submit_button} />}
      modalContentProps={{
        w: '100%',
        maxW: { base: '90vw', xl: '1200px' },
        minW: '350px',
      }}
      modalBodyProps={{
        maxH: '80dvh',
        height: 'auto',
        pointerEvents: isLoading ? 'none' : 'auto',
        opacity: isLoading ? 0.5 : 1,
      }}
      modalHeaderProps={{
        boxShadow: 'none',
        pointerEvents: isLoading ? 'none' : 'auto',
        opacity: isLoading ? 0.5 : 1,
      }}
      modalFooterProps={{
        pointerEvents: isLoading ? 'none' : 'auto',
        opacity: isLoading ? 0.5 : 1,
      }}
    />
  )
}
